import { Stack } from '@mui/material';
import { CheckboxInput } from 'Components';
import { DocumentsContext } from 'Context/DocumentsContext';
import { DOCUMENTS_REDUCER_CASE } from 'Enum/documents';
import { ResetFilterButtons } from 'Modules/Suppliers/SuppliersMain/ResultsPages/Header/DynamicAdvancedFilter/ResetFilterButtons';
import { useContext } from 'react';

interface IDateOption {
  key: string;
  label: string;
  value: boolean;
}

interface IDatePeriod {
  options: IDateOption[];
}

export const DatePeriod = ({ options }: IDatePeriod) => {
  const { filter, dispatchDocuments, advancedFilterActivationHandler } =
    useContext(DocumentsContext);

  const datePeriodFilterHandler = (
    key: keyof typeof filter.datePeriod,
    value: boolean
  ) => {
    const updatedFilter = { ...filter };
    updatedFilter.datePeriod[key] = !value;
    advancedFilterActivationHandler(updatedFilter);
    dispatchDocuments({
      type: DOCUMENTS_REDUCER_CASE.FILTER,
      payload: {
        value: { filter: updatedFilter },
      },
    });
  };

  const restDatePeriodFilterHandler = () => {
    const updatedFilter = { ...filter };
    const datePeriod = {
      lastMonth: false,
      lastWeek: false,
      lastYear: false,
    };
    updatedFilter.datePeriod = datePeriod;
    advancedFilterActivationHandler(updatedFilter);
    dispatchDocuments({
      type: DOCUMENTS_REDUCER_CASE.FILTER,
      payload: {
        value: { filter: updatedFilter },
      },
    });
  };

  return (
    <Stack
      sx={{
        pb: '50px',
      }}
      tabIndex={-1}
    >
      {options.map((option: IDateOption, index: number) => {
        return (
          <CheckboxInput
            key={index}
            checked={option.value}
            label={option.label}
            onChange={() =>
              datePeriodFilterHandler(
                option.key as keyof typeof filter.datePeriod,
                option.value
              )
            }
            containerStyle={{
              '.MuiCheckbox-root': {
                m: '8px 0',
                p: '0 5px 0 16px',
              },
            }}
            textSx={{
              fontWeight: false ? '600 !important' : undefined,
              ':hover': {
                fontWeight: 600,
              },
            }}
          />
        );
      })}
      <ResetFilterButtons
        resetCallback={restDatePeriodFilterHandler}
        sx={{
          pl: '8px',
          justifyContent: 'flex-start',
        }}
      />
    </Stack>
  );
};
